import { render } from "./BrandActionOverlays.vue?vue&type=template&id=01b43967&scoped=true"
import script from "./BrandActionOverlays.vue?vue&type=script&lang=js"
export * from "./BrandActionOverlays.vue?vue&type=script&lang=js"

import "./BrandActionOverlays.vue?vue&type=style&index=0&id=01b43967&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b43967"]])

export default __exports__